import { IEventBus } from "./event-bus/IEventBus";
import EventBus from "./event-bus/event-bus";
import { IWebSocketService } from "./socket/IWebSocketService";
import SocketService from "./socket/webSocketService";

const eventBus: IEventBus = new EventBus();
const socketService: IWebSocketService = new SocketService(eventBus);

export { eventBus, socketService };
